import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-infobulle',
  templateUrl: './infobulle.component.html',
})
export class InfobulleComponent {

  @Input() title: string;

}
